module.exports = __webpack_public_path__ + "static/media/stara.60e4a629.png";